import { HTMLAttributes } from 'react'

export const MetricCardNumber = ({
  className,
  ...props
}: HTMLAttributes<HTMLElement>) => (
  <strong
    className="flex w-full items-center justify-center gap-1.5 text-3xl"
    {...props}
  />
)
